import React, { useState, createContext } from "react";

export const PlayersRankingContext = createContext<any[]>([]);
